import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp24};
  align-items: center;
`

export const RatingContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};

  input {
    display: none;
  }

  svg {
    font-size: 3rem;
  }
`
